module.exports = __webpack_public_path__ + "static/back-to-top@2x-a68e4fc901749faa226e82893cf91954.png";